import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './css/App.css';
import {ListElement} from './ListElement';
import {buildQueryString} from "./Util";
import {fetchPage, fetchSelectUser, getPageContent, getStatus} from './mySlice';
import Header from './Header';
import Footer from './Footer';
import {ErrorPage} from "./ErrorPage";

function App() {
  const dispatch = useDispatch();
  const pageContent = useSelector(getPageContent);

  let profileListContent;
  if (pageContent.partyCards) {
    profileListContent = pageContent.partyCards;
  } else {
    profileListContent = [];
  }

  let errorDTO;
  if (pageContent.errorDTO) {
    errorDTO = {
       ...pageContent.errorDTO,
       ...(pageContent.redirectUrl && { redirectUrl: pageContent.redirectUrl })
    };
  }

  const profileList = profileListContent;
  const status = useSelector(getStatus);

  function loadFrame() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = '/static-ut-frame/frame.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  useEffect(() => {
    console.log('window.location.href: '+ window.location.href);
    if (!(window.location.href.includes("localhost"))) {
      console.log('Try to use MT common frame');

      loadFrame()
        .then((event) => {
          console.log('MT common frame loaded');
        })
        .catch((error) => {
          console.error('MT common frame failed to load', error);
        });

    } else {
      console.log('MT common frame not loaded')
    }

    const searchParams = new URLSearchParams(document.location.search)
    let query = buildQueryString(searchParams);
    dispatch(fetchPage(query))

  }, []);

  const select = (productId, customerId, successUrl) => {
    const queryParams = new Map();
    queryParams.set("productId", productId);
    queryParams.set("customerId", customerId);
    queryParams.set("successUrl", successUrl);
    const query = buildQueryString(queryParams);

    dispatch(fetchSelectUser(query));
  };

  return (
    <>
      <Header dataDomain="uzleti" dataType="hu" dataTheme="light-topmenu" dataIsPreview="false" dataSearchEnabled="true" dataIsMain="false" dataIsMyts="false" dataLanguageEnabled="true" />
      <div className="row invoice-outer">
        <main className="wrapper invoice-inner" id="frame-container">
          <section className="main-content">
            <div style={{ display: "inherit" }}>
              <div className="page-out-wrapper page-container  mt-3  pageRoleSelectorContent ">
                <div className="page-body">
                  {errorDTO ? <ErrorPage {...errorDTO}/> :
                      <div className="invoice-details-row m2m-maincontent-row panel-container">
                        <div className="clearfix"/>
                        <div className=" title-row-container">
                      <span className="inv-details-title">
                        <div className="flex-row  left-items-row">
                          {status === "redirect" ?
                              <>
                                <div>
                                <span className="inv-details-title ps-3 w-100 border-0 m-0 pb-0" style={{
                                  borderBottom: "0px",
                                  marginBottom: "0px",
                                  paddingBottom: "0px",
                                  paddingLeft: 16
                                }}>
                              Átirányítás folyamatban
                              </span>
                                </div>
                              </>
                              :
                              <>
                              <span className="title-icon ">
                            <div className="exticon-png-cap-select " alt=""/>
                          </span>
                                <span className="inv-details-title ps-3 w-100 border-0 m-0 pb-0" style={{
                                  borderBottom: "0px",
                                  marginBottom: "0px",
                                  paddingBottom: "0px",
                                  paddingLeft: 16
                                }}>
                            Válaszd ki,hogy melyik cég felhasználójaként szeretnél ügyet intézni!
                            </span>
                              </>
                          }
                        </div>
                      </span>
                        </div>
                        {status === "redirect" || profileList === 'undefined' || profileList.length === 0 ?
                            <>
                              <div className="loading-animation-container">
                                <div className="loader-animation">Betöltés...</div>
                              </div>
                            </>
                            :
                            <>
                              {profileList.map(({
                                                  partyName,
                                                  details,
                                                  owner,
                                                  productId,
                                                  customerId,
                                                  successUrl
                                                }, index) => {
                                return (
                                    <ListElement key={index} id={index} partyName={partyName} details={details}
                                                 owner={owner} productId={productId} customerId={customerId} successUrl={successUrl} onSelect={() => select(productId, customerId, successUrl)}/>
                                );
                              })}
                            </>
                        }
                      </div>
                  }

                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer dataDomain="uzleti" dataType="hu" dataTheme="default" dataIsPreview="false" />
    </>
  );
}

export default App;
